const loginAndSignUp = {
  loginTips: "¿Ya tiene una cuenta HitPaw? <1>Iniciar sesión</1>",
  loginSuccessTips: "Iniciar sesión con éxito",
  loginErrorTips: "Error de iniciar sesión",
  loginAccountOrPasswordErrorTips: "Su dirección de correo electrónico o su contraseña son incorrectas. Por favor, inténtelo de nuevo.",
  loginAccountNotExitErrorTips: "El correo electrónico no está registrado",
  signUpTips: "¿Aún no es un usuario registrado?",
  rememberMe: "Recordarme",
  forgotPassword: "¿Olvidó su contraseña?",
  forgotPasswordTitle: "Olvidé mi contraseña",
  verifyEmailBtn: "Verificar correo electrónico",
  resetPasswordTitle: "Restablecer la contraseña",
  resetPasswordLabel: "Por favor, restablezca su contraseña",
  resetPasswordPlaceholder: "Introduzca una nueva contraseña",
  resetPasswordSuccessTips: "Contraseña restablecida con éxito",
  signUpPrivacyTips: "Al registrarte, aceptas nuestros <1>Servicios de Uso</1> y <3>Política de Privacidad</3>",
  loginPrivacyTips: "Al iniciar sesión, acepta nuestro <1>Servicios de Uso</1> y <3>Política de Privacidad</3>",
  signUpSuccessTips: "Su cuenta ha sido registrada con éxito！",
  getCode: "Obtener Código",
  getCodeSuccessTips: "Se ha enviado a su buzón de correo, por favor, compruébelo",
  verificationSuccessTips: "La verificación de la dirección de correo electrónico se ha realizado con éxito",
  surveyTitle: "Bienvenido a HitPaw Online",
  surveyStep1: "<1>Paso 1</1>/3",
  surveyStep2: "<1>Paso 2</1>/3",
  surveyStep3: "<1>Paso 3</1>/3",
  surveyQuestion: "¿Cuál es el propósito de usar HitPaw?",
  surveyThemeQuestion: "Elija el modo que desee",
  surveyAnswerOther: "Otros",
  surveyAnswer1: "Video de estilo de vida",
  surveyAnswer2: "Video de negocios",
  surveyAnswer3: "Vídeo de empresa",
  surveyAnswer4: "Vídeo de márketing",
  surveyAnswer5: "Vídeo de medios sociales",
  surveyAnswer6: "Vídeo de presentación de diapositivas",
  surveyAnswer7: "Herramienta de vídeo",
  surveyAnswer8: "Vídeo de viajes",
  surveyAnswer9: "Vídeo de boda",
  surveyAnswer10: "Vídeo de cumpleaños",
  surveyAnswer11: "Vídeo de bebés",
  surveyAnswer12: "Vídeo de animales",
  surveyAnswer13: "Vídeo de comida",
  surveyAnswer14: "Vídeo de moda",
  surveyAnswer15: "Vídeo de vacaciones",
  surveyAnswer16: "Vídeo de deportes",
  surveyAnswer17: "Vídeo de fotografía",
  surveyAnswer18: "Vídeo de música",
  surveyAnswerLightMode: "Modo luz",
  surveyAnswerDarkMode: "Modo oscuro",
  surveyNextBtn: "Siguiente",
  surveyBackBtn: "Volver",
  surveyDoneBtn: "Hecho",
  surveyStartBtn: "Comenzar",
  logoutWarnTips: "¿Está seguro de cerrar la sesión?",
};

export default loginAndSignUp;
